import React from "react";
import { StyleSheet, Text, View } from "react-native";

import Colors from "../../../Resources/Color";

export function NutritionEmptyState({ eyebrow, title, description }) {
  return (
    <View style={styles.container}>
      <View style={styles.card}>
        {eyebrow ? <Text style={styles.eyebrow}>{eyebrow}</Text> : null}
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.description}>{description}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  card: {
    width: "100%",
    maxWidth: 720,
    padding: 24,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    borderRadius: 16,
    backgroundColor: Colors.whiteColor,
  },
  eyebrow: {
    fontSize: 12,
    fontWeight: "600",
    color: Colors.bubbleColor,
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: 0.8,
  },
  title: {
    fontSize: 26,
    fontWeight: "700",
    color: Colors.blackColor,
    marginBottom: 12,
  },
  description: {
    fontSize: 16,
    lineHeight: 24,
    color: Colors.darkgrayColor,
  },
});
